module.exports = __webpack_public_path__ + "img/password.6db63306.svg";